import { FunctionComponent, useEffect } from 'react';

export const CustomModalBackground = ({ onClose }: { onClose?(): void }) => (
	<div className='r4-overlay' onClick={onClose}></div>
);

export const CustomModal: FunctionComponent<{
	disableEscDismiss?: boolean;
	topOffset?: number;
	onClose?(): void;
}> = ({ children, disableEscDismiss = false, topOffset = 0, onClose }) => {
	useEffect(() => {
		if (disableEscDismiss) {
			return () => {};
		}

		const listener = (event: KeyboardEvent) => {
			switch (event.key) {
				case 'Esc':
				case 'Escape':
					onClose?.();
				default:
					return;
			}
		};
		document.body.addEventListener('keyup', listener);
		return () => {
			document.body.removeEventListener('keyup', listener);
		};
	}, [disableEscDismiss, onClose]);

	return <>{children || null}</>;
};

CustomModal.displayName = 'UI.CustomModal';

export const ModalFooter: React.FunctionComponent = ({ children }) => (
	<div className='bg-gray-100 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse rounded-lg'>{children}</div>
);

ModalFooter.displayName = 'UI.ModalFooter';
